import DashboardIcon from "../assets/icons/dashboard.svg";
import DocumentArrowRight from "../assets/icons/document-arrow-right.svg";
import FinanceIcon from "../assets/icons/finance.svg";
import AcademicIcon from "../assets/icons/academic.svg";
import InsightsIcon from "../assets/icons/insights-icon.svg";
import PredictionIcon from "../assets/icons/prediction.svg";
import DefaultingStudentsIcon from "../assets/icons/defaulting-students.svg";
// import MarketingIcon from "../assets/icons/marketing.svg";
// import AdministrativeIcon from "../assets/icons/administrative.svg";
import UsersIcon from "../assets/icons/users.svg";
import UserIcon from "../assets/icons/user.svg";
import BellIcon from "../assets/icons/bell.svg";
import SettingsIcon from "../assets/icons/settings.svg";
import DocumentCheckIcon from "../assets/icons/document-check.svg";
import DatabaseMoneyIcon from "../assets/icons/database-money.svg";
import BookIcon from "../assets/icons/book.svg";
import ClassesIcon from "../assets/icons/classes.svg";
import InstitutionIcon from "../assets/icons/institution.svg";
import RegulatoryIcon from "../assets/icons/regulatorio.svg";

export const PAGES_ITENS = {
  INDICATORS: [
    {
      title: "Dashboard",
      icon: DashboardIcon,
      path: "/app/dashboard",
      className: "dashboard-sidebar"
    },
    { title: "Financeiro", icon: FinanceIcon, path: "/app/financeiro", className: "finance-sidebar" },
    { title: "Regulatorio", icon: RegulatoryIcon, path: "/app/regulatorio", className: "regulatorio-sidebar" },
    { title: "Acadêmico", icon: AcademicIcon, path: "/app/academico", className: "education-sidebar" },
    { title: "Insights", icon: InsightsIcon, path: "/app/insights", className: "insights-sidebar" },
    {
      title: "Predição",
      icon: PredictionIcon,
      path: "/app/predicao",
      className: "prediction-sidebar",
      hasDropdown: true,
      subItems: [
        {
          title: "Inadimplência",
          icon: DatabaseMoneyIcon,
          path: "/app/predicao",
          className: "prediction-sidebar"
        },
        {
          title: "Evasão",
          icon: DefaultingStudentsIcon,
          path: "/app/possiveis-evasores",
          className: "dropout-risk-sidebar"
        }
      ]
    },
    { title: "Alunos Inadimplentes", icon: DefaultingStudentsIcon, path: "/app/alunos-inadimplentes", className: "defaulting-sidebar" },
    { title: "Dashboard Customizado", icon: DashboardIcon, path: "/app/dashboard-customizado", className: "custom-dashboard-sidebar" },
    {
      title: "Dados Consolidados",
      icon: DocumentCheckIcon,
      path: "/app/dados-consolidados",
      className: "consolidated-data-sidebar",
      hasDropdown: true,
      subItems: [
        {
          title: "Dados de Faturamento",
          icon: DatabaseMoneyIcon,
          path: "/app/dados-consolidados",
          className: "consolidated-data-sidebar"
        },
        {
          title: "Dados Acadêmicos",
          icon: BookIcon,
          path: "/app/dados-consolidados-academicos",
          className: "education-consolidated-data-sidebar"
        },
        {
          title: "Dados de Turmas",
          icon: ClassesIcon,
          path: "/app/dados-consolidados-turmas",
          className: "class-consolidated-data-sidebar"
        },
        {
          title: "Dados de Adesão",
          icon: AcademicIcon,
          path: "/app/dados-consolidados-adesao",
          className: "adhesion-consolidated-data-sidebar"
        },
        {
          title: "Dados de Docentes",
          icon: UsersIcon,
          path: "/app/dados-consolidados-docentes",
          className: "teacher-consolidated-data-sidebar"
        }
      ]
    },
    // { title: "Marketing", icon: MarketingIcon, path: "/app/marketing" },
    // { title: "Instituição", icon: InstitutionIcon, path: "/app/institution" },
    // { title: "Administrativo", icon: AdministrativeIcon, path: "/app/admin" }
  ],
  // Itens exclusivos de gestores da mantenedora (rede educacional).
  // Admin de uma mantida específica não deve ter acesso a essas telas, pois
  // elas listam dados consolidados de TODAS as instituições da rede e
  // permitem criar novas mantidas — operações que só fazem sentido para
  // quem administra a rede como um todo.
  MANTENEDORA: [
    {
      title: "Mantenedora",
      icon: InstitutionIcon,
      path: "/app/mantenedora",
      className: "mantenedora-sidebar",
      roles: ["MantenedoraAdmin", "MantenedoraManager"]
    },
    {
      title: "Instituições",
      icon: InstitutionIcon,
      path: "/app/instituicoes",
      className: "institutions-sidebar",
      roles: ["MantenedoraAdmin", "MantenedoraManager"]
    },
    {
      title: "Gestão de Usuários",
      icon: UsersIcon,
      path: "/app/gestao-usuarios",
      className: "mantenedora-users-sidebar",
      roles: ["MantenedoraAdmin", "MantenedoraManager"]
    }
  ],
  SYSTEM: [
    {
      title: "Meu Perfil",
      icon: UserIcon,
      path: "/app/meu-perfil",
      className: "profile-sidebar"
    },
    {
      title: "Usuários",
      icon: UsersIcon,
      path: "/app/usuarios",
      className: "users-sidebar"
    },
    {
      title: "Notificações",
      icon: BellIcon,
      path: "/app/notificacoes",
      className: "notifications-sidebar"
    },
    {
      title: "Importar Dados",
      icon: DocumentArrowRight,
      path: "/app/importar-dados",
      className: "import-data-sidebar"
    },
    {
      title: "Configurações",
      icon: SettingsIcon,
      path: "/app/configuracoes",
      className: "settings-sidebar"
    }
  ]
};

export const PHONE_REGEX_FORMATTER = /^(\d{2})(\d{5})(\d{4})$/;
export const PHONE_REGEX = /^\(\d{2}\) 9\d{4}-\d{4}$/;

export const FILES_MAPPING = {
  academico: {
    modalTile: "Enviar arquivo academico",
    file: "academico.csv",
    url: "academicImport"
  },
  aluno: {
    modalTile: "Enviar arquivo de alunos",
    file: "aluno.csv",
    url: "studentImport"
  },
  turma: {
    modalTile: "Enviar arquivo de turmas",
    file: "turma.csv",
    url: "classImport"
  },
  adesao: {
    modalTile: "Enviar arquivo de adesão",
    file: "adesao.csv",
    url: "adhesionImport"
  },
  captacao: {
    modalTile: "Enviar arquivo de captação",
    file: "captacao.csv",
    url: "captivationImport"
  },
  faturamento: {
    modalTile: "Enviar arquivo de faturamento",
    file: "faturamento.csv",
    url: "turnoverImport"
  },
  docente: {
    modalTile: "Enviar arquivo de docentes",
    file: "docente.csv",
    url: "teacherImport"
  },
  // financeiro: {
  //   modalTile: "Enviar arquivo financeiro",
  //   file: "financeiro.csv",
  //   url: "financeImport"
  // },
};
